// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__13QqT","inputWrap":"Table_inputWrap__2migr","col":"Table_col__3hNp2","bmiTooltip":"Table_bmiTooltip__1U2WX"};